import { render } from "./LikeOnFacebook.vue?vue&type=template&id=346327dd&scoped=true"
import script from "./LikeOnFacebook.vue?vue&type=script&lang=js"
export * from "./LikeOnFacebook.vue?vue&type=script&lang=js"

import "./LikeOnFacebook.vue?vue&type=style&index=0&id=346327dd&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-346327dd"]])

export default __exports__